import * as d3 from 'd3';

export const weekRange = (weekCount, format) => (startDate) => {
  const formatLabel = d3.timeFormat(format);
  let endDate = d3.timeWeek.offset(startDate, weekCount);
  endDate = d3.timeDay.offset(endDate, -1);
  return `${formatLabel(startDate)} - ${formatLabel(endDate)}`;
};
